import React, { Component } from 'react'
import PropTypes from 'prop-types'

class CommentAvatar extends Component {
  static propTypes = {
    user: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      errorLoadingImage: false
    }
  }

  renderUserInitials = user => {
    return (
      <div className='comments-wrapper__comment__image__initials'>
        <h1>{user.firstName.charAt(0) + user.lastName.charAt(0)}</h1>
      </div>
    )
  }

  renderUserImage = user => {
    const src = `/uploads/${user.picture.path}`
    return (
      <img
        src={src}
        alt='Avatar'
        className='comments-wrapper__comment__image__avatar'
      />
    )
  }

  onError = e => {
    this.setState({ errorLoadingImage: true })
  }

  render () {
    const { user } = this.props
    if (!user) return null

    const cantLoadImage =
      !user.picture || !user.picture.path || this.state.errorLoadingImage

    if (cantLoadImage) {
      return this.renderUserInitials(user)
    }

    const src = `/uploads/${user.picture.path}`
    return (
      <img
        src={src}
        alt='Avatar'
        className='comments-wrapper__comment__image__avatar'
        onError={this.onError}
      />
    )
  }
}

export default CommentAvatar
